import styled from 'styled-components';
import { Box, BoxProps } from '@mui/material';
import { colors } from 'spw-theme';
import React from 'react';
import { AlignEndColumn } from 'spw-shared/globalComponents/grid';
import CardAtom from 'spw-components/atomic/atoms/card';

export const Card = CardAtom;

export const KeyDataPointsCard = styled(Card)`
  && {
    height: 200px;
  }
`;

export const MediumCard = styled(Card)`
  && {
    height: 130px;
  }
`;

export const UsfCard = styled(Card)`
  && {
    height: 88px;
  }
`;

export const CardTitle = styled.div`
  && {
    &.mb-8 {
      margin-bottom: 8px;
    }
    font-weight: 500;
    font-size: 12px;
    line-height: 12px;
    display: flex;
    align-items: center;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    margin-bottom: 16px;
    color: ${colors.mainGray};
  }
`;

export const PaddedCardTitle = styled(CardTitle)`
  && {
    margin-bottom: 40px;
  }
`;

export const ProjectOverviewCardTitle = styled(CardTitle)`
  && {
    width: 100%;
    height: 16px;
  }
`;

export const CardValue = styled.div`
  && {
    font-weight: 500;
    font-size: 18px;
    line-height: 20px;
    color: ${colors.black};
    margin-bottom: 4px;
  }
`;

export const DepartmentValue = styled(CardValue)`
  && {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    &.secondary-identifier {
      font-size: 14px;
      line-height: 16px;
      margin-top: -12px;
    }
    font-size: 18px;
    line-height: 20px;
  }
`;

export const SecondaryIdentifierValue = styled.div`
  && {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-style: normal;
    color: ${colors.black};
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    transform: translateY(-2px);
  }
`;

export const BoldNumber = styled.div`
  && {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
  }
`;

export const Sign = styled.span`
  margin: 0px 8px;
`;

export const MultiplicationSign = styled(Sign)`
  color: ${colors.black};
`;

export const DeltaCardValue = styled(CardValue)`
  && {
    &.positive {
      color: ${colors.lightGreen};
    }
    &.negative {
      color: ${colors.red};
    }
  }
`;

export const KeyDataPointColumnContainer = styled(Box)`
  && {
    padding-left: 8px;
    padding-right: 15px;

    &.padding-0 {
      padding-left: 0px;
    }
    &.left-border {
      border-left: 1px solid #dfdfdf;
    }
    &.right-border {
      border-right: 1px solid #dfdfdf;
    }
  }
`;

export const KeyDataPointColumn = styled(Box)`
  && {
    padding: 8px;

    &.last {
      margin-bottom: 0px;
    }

    &:hover {
      &.highlight {
        background: #eeeeee;
        border-radius: 4px;
        cursor: pointer;
      }
    }
  }
`;

export const AnalysisRow = styled((props: BoxProps) => (
  <Box display="flex" {...props} />
))`
  && {
    padding: 8px 0px;
    margin-bottom: 9px;

    .highlight:hover {
      background: #eeeeee;
      border-radius: 4px;
      cursor: pointer;
    }
  }
`;

export const HeadcountSmallIconWrapper = styled(Box)`
  && {
    margin-right: 8px;
    max-width: 40px;
  }
`;

export const SeatCountIconWrapper = styled(Box)`
  && {
    padding-left: 4px;
    padding-right: 19px;
  }
`;

export const SeatCountSmallIconWrapper = styled(SeatCountIconWrapper)`
  && {
    padding-right: 8px;
    max-width: 40px;
  }
`;

export const CardRow = styled(Box)`
  && {
    font-weight: normal;
    font-size: 12px;
    line-height: normal;
    color: ${colors.fontColor};
    margin-bottom: 4px;
  }
`;

export const PercentValue = styled.span`
  && {
    font-weight: 500;
    padding-left: 2px;
  }
`;

export const PillText = styled.span`
  && {
    margin-left: 4px;
  }
`;

export const CirculationTitle = styled.div`
  width: 130px;
`;
export const PlaningFactorTitle = styled.div`
  width: 130px;
`;

export const MeetingSeatRatioRow = styled(Box)`
  && {
    padding: 8px 0;
    margin-bottom: 19px;
    .highlight:hover {
      background: #eeeeee;
      border-radius: 4px;
      cursor: pointer;
    }
  }
`;

export const PercentBarContainer = styled.div`
  && {
    width: 232px;
    height: 16px;
    background-color: #eeeeee !important;
    border: none !important;
    margin-top: 5px;
  }
`;

export const PaddedAlignEndColumn = styled(AlignEndColumn)`
  && {
    padding-top: 28px;
  }
`;

export const SeatCountUsfBox = styled((props: BoxProps) => <Box {...props} />)`
  && {
    &.left {
      margin: 0px 0px 0px -8px;
    }

    &.right {
      margin: 0px -8px 0px 0px;
    }
    padding: 8px;
    border-radius: 4px;

    .highlight:hover {
      background: #eeeeee;
      cursor: pointer;
      border-radius: 4px;
    }
  }
`;

export const UsfBreakdownBox = styled((props: BoxProps) => <Box {...props} />)`
  && {
    padding: 0 8px;
    border-radius: 11px;
    margin: 0 -8px;
    width: 100%;
    display: flex;

    &:hover {
      &.highlight {
        background: #eeeeee;
        cursor: pointer;
      }
    }
  }
`;
